// Centralized application constants for reuse across FE
import { DEFAULT_ADMIN_SECTION, ENABLED_ADMIN_SECTIONS, GRAPH_SEARCH_STORAGE_KEY } from "../utils/navigation.js";

export const ROLE_ADMIN = "admin";
export const ROLE_EDITOR = "editor";
export const ROLE_APPROVER = "approver";
export const ROLE_VIEWER_RESTRICTED = "SCX_Viewer_Restricted";

export const DEFAULTS = {
  DEFAULT_ADMIN_SECTION,
  ENABLED_ADMIN_SECTIONS,
  GRAPH_SEARCH_STORAGE_KEY,
};

// Admin menu item keys — reused by Header and admin navigation
export const ADMIN_MENU_KEYS = {
  REQUESTS: "requests",
  TRACK_APPROVALS: "track-approvals",
  TRACK_REQUESTS: "track-requests",
  AUDIT_LOG: "audit-log",
  PROCESS_FLOW: "process-flow",
};

export default {
  ROLE_ADMIN,
  ROLE_EDITOR,
  ROLE_APPROVER,
  ROLE_VIEWER_RESTRICTED,
  ADMIN_MENU_KEYS,
  DEFAULTS,
};
